import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicDocument() {
  const { id } = useParams();
  const [doc, setDoc] = useState(undefined);

  useEffect(() => {
    axios.get(`${API}/documents/${id}`).then((r) => setDoc(r.data)).catch(() => setDoc(null));
  }, [id]);

  if (doc === undefined) return <div className="min-h-screen grid place-items-center font-mono text-sm text-charcoal/50">Loading…</div>;
  if (doc === null) return (
    <div className="min-h-screen grid place-items-center bg-bone px-6 text-center">
      <div>
        <h1 className="font-serif text-4xl">Document not found</h1>
        <p className="font-sans text-charcoal/55 mt-3">This document may have been removed.</p>
      </div>
    </div>
  );

  const isImage = doc.content_type && doc.content_type.startsWith("image/");
  const isPdf = doc.content_type === "application/pdf";
  const fileUrl = doc.file_url ? `${process.env.REACT_APP_BACKEND_URL}${doc.file_url}` : null;

  return (
    <div className="min-h-screen bg-bone" data-testid="public-document">
      <div className="bg-charcoal py-5 px-6">
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-gold">In His Image Movement Ministries</span>
      </div>
      <div className="max-w-3xl mx-auto px-6 py-14">
        <h1 className="font-serif text-4xl md:text-5xl tracking-tight text-charcoal" data-testid="public-document-title">{doc.title}</h1>
        <div className="mt-8">
          {doc.kind === "created" && (
            <div className="font-sans text-charcoal/85 leading-relaxed prose-doc" dangerouslySetInnerHTML={{ __html: doc.content_html }} />
          )}
          {doc.kind === "upload" && isImage && (
            <img src={fileUrl} alt={doc.title} className="w-full border border-charcoal/10" data-testid="public-document-image" />
          )}
          {doc.kind === "upload" && isPdf && (
            <iframe src={fileUrl} title={doc.title} className="w-full h-[80vh] border border-charcoal/10" data-testid="public-document-pdf" />
          )}
          {doc.kind === "upload" && !isImage && !isPdf && (
            <a href={fileUrl} download className="inline-flex items-center gap-2 bg-charcoal text-bone px-6 py-3 font-mono text-xs uppercase tracking-widest hover:bg-navy transition-colors" data-testid="public-document-download">
              Download {doc.original_filename}
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
